import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  DialogContent,
  TextField,
  Checkbox,
  FormControlLabel
} from "@material-ui/core";

import {
  addProcess,
  getMetadata,
  displayError
} from "../../actions/processActions";
import { closeProcessModal } from "../../actions/modalActions";

import "../../styles/processModal.scss";

class ProcessModal extends Component {
  state = {
    formData: { isotropic: false }
  };

  handleClose = () => {
    if (new Date() - this.props.modalOpenTime > 1000) {
      this.props.closeProcessModal();
    }
  };

  handleSubmit = async () => {
    const metadata = await getMetadata(this.state.formData.reference);

    if (!metadata) {
      this.props.displayError("Could not retrieve metadata for provided DOI");
      return;
    }

    this.props.addProcess({
      ...this.state.formData,
      ...metadata
    });

    this.handleClose();
  };

  handleChangeFormData = (key, value) => {
    this.setState({ formData: { ...this.state.formData, [key]: value } });
  };

  render() {
    const actions = [
      <Button label="Cancel" color="secondary" onClick={this.handleClose}>
        Cancel
      </Button>,
      <Button color="primary" keyboardfocused onClick={this.handleSubmit}>
        Submit
      </Button>
    ];

    return (
      <>
        <Dialog
          open={this.props.isOpen}
          onClose={this.handleClose}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Add a new process</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              label="Your name (optional)"
              value={this.state.formData.contributor}
              onChange={event =>
                this.handleChangeFormData("contributor", event.target.value)
              }
            />
            <TextField
              margin="dense"
              label="Material"
              value={this.state.formData.material}
              onChange={event =>
                this.handleChangeFormData("material", event.target.value)
              }
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.formData.isotropic}
                  label="Isotropic"
                  onChange={event =>
                    this.handleChangeFormData("isotropic", event.target.checked)
                  }
                />
              }
              label="Isotropic"
            />
            <br />
            <TextField
              margin="dense"
              label="Reactant A"
              value={this.state.formData.reactantA}
              onChange={event =>
                this.handleChangeFormData("reactantA", event.target.value)
              }
            />
            <TextField
              margin="dense"
              label="Reactant B"
              value={this.state.formData.reactantB}
              onChange={event =>
                this.handleChangeFormData("reactantB", event.target.value)
              }
            />
            <br />
            <TextField
              margin="dense"
              label="Other reactants (optional)"
              value={this.state.formData.reactantC}
              fullWidth
              onChange={event =>
                this.handleChangeFormData("reactantC", event.target.value)
              }
            />

            <br />
            <TextField
              margin="dense"
              label="Reference (DOI)"
              value={this.state.formData.reference}
              fullWidth
              onChange={event =>
                this.handleChangeFormData("reference", event.target.value)
              }
            />
            <br />
            <TextField
              margin="dense"
              label="Note"
              value={this.state.formData.note}
              multiline
              fullWidth
              onChange={event =>
                this.handleChangeFormData("note", event.target.value)
              }
            />
          </DialogContent>
          <DialogActions>{actions}</DialogActions>
        </Dialog>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    isOpen: state.modal.processModalIsOpen,
    modalOpenTime: state.modal.modalOpenTime
  };
}

export default connect(
  mapStateToProps,
  { addProcess, closeProcessModal, displayError }
)(ProcessModal);
